export const parityNotificationQueryKeys = {
  all: ['parity-notifications'] as const,
  vendorOffers: (vendorId: string) => [...parityNotificationQueryKeys.all, 'vendor-offers', vendorId] as const,
  offerSelection: (offerId: string, vendorId: string) =>
    [...parityNotificationQueryKeys.all, 'offer-selection', offerId, vendorId] as const,
  unsolvedParity: () => [...parityNotificationQueryKeys.all, 'unsolved', 'price_parity'] as const,
  unsolvedLowInventory: () => [...parityNotificationQueryKeys.all, 'unsolved', 'low_inventory'] as const,
};
